// `/app/checkout/links/$id`: gaveta "Editar link" por cima da tela. Fechar volta pra lista.

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { EditLinkDrawer } from '../../../features/checkout/edit-link-drawer.tsx';
import { useFeatureDisabled } from '../../../features/checkout/feature-disabled.tsx';

function EditLink() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { markDisabled } = useFeatureDisabled();
  return (
    <EditLinkDrawer
      id={id}
      onClose={() => {
        void navigate({ to: '/app/checkout' });
      }}
      onFeatureDisabled={markDisabled}
    />
  );
}

export const Route = createFileRoute('/app/checkout/links/$id')({ component: EditLink });
